export default __webpack_public_path__ + "maps-examples-default-styles-960-42b3a83ebacab467f9049fe63fbc96f2.webp";